export class XhrRequest  {

    constructor() {

    }
}

